import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useContext, useEffect } from 'react';
import { useAuthFunctions, useAuth } from '../hook';
import { tokenKeyName } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var AuthContext = /*#__PURE__*/createContext(null);

var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children,
      baseUrl = _ref.baseUrl;

  var _useAuthFunctions = useAuthFunctions(baseUrl),
      state = _useAuthFunctions.state,
      login = _useAuthFunctions.login,
      logout = _useAuthFunctions.logout,
      signUp = _useAuthFunctions.signUp,
      resetPassword = _useAuthFunctions.resetPassword,
      initializeAuthentication = _useAuthFunctions.initializeAuthentication,
      verifyToken = _useAuthFunctions.verifyToken,
      invalidateSession = _useAuthFunctions.invalidateSession,
      initialize = _useAuthFunctions.initialize;

  useEffect(function () {
    var accessToken = localStorage.getItem(tokenKeyName) || undefined;
    initialize(accessToken); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      method: 'jwt',
      login: login,
      logout: logout,
      signUp: signUp,
      resetPassword: resetPassword,
      initializeAuthentication: initializeAuthentication,
      verifyToken: verifyToken,
      invalidateSession: invalidateSession,
      initialize: initialize
    }),
    children: children
  });
};

var useAuthContext = function useAuthContext() {
  return useContext(AuthContext);
};

export { AuthProvider, useAuth, useAuthContext };